const LiveRegion = ({ message }: { message: string }) => (
  <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
    {message}
  </div>
);

export default LiveRegion;